import { useCurrentClub } from '@/hooks/use-current-club';
import { urlCategoryList, urlEditCategory } from '@/urls';
import { productApi } from '@repo/api-client';
import { UpdateProductCategory } from '@repo/shared-types';
import { Input } from '@repo/ui/components/form/input';
import { Button } from '@repo/ui/components/button';
import { useAsync } from '@repo/ui/hooks/use-async';
import { useForm } from '@repo/ui/hooks/use-form';
import { LoaderFunctionArgs, useLoaderData, useNavigate } from 'react-router';

function EditCategory() {
  const category = useLoaderData<typeof route.loader>();
  const club = useCurrentClub();
  const navigate = useNavigate();
  const { execute: onSubmit } = useAsync(async () => {
    await productApi.updateCategory(club.id, category.id as string, values);
    navigate(urlCategoryList(club.id), { viewTransition: true });
  });
  const { ref, values, errors } = useForm<UpdateProductCategory>({
    initialValues: {
      name: category.name,
      description: category.description,
    },
    onSubmit,
  });
  return (
    <form ref={ref}>
      <Input label="Nombre" type="text" name="name" required errors={errors} />
      <Input label="Descripción" type="text" name="description" required errors={errors} />
      <Button type="submit">Guardar</Button>
    </form>
  );
}

export const route = {
  path: urlEditCategory(':id', ':categoryId'),
  element: <EditCategory />,
  handle: {
    title: (data: { name: string }) => `Editar categoría ${data.name}`,
    backLink: (params: { id: string; categoryId: string }) => urlCategoryList(params.id),
  },
  loader: async ({ params }: LoaderFunctionArgs) => {
    const clubId = params.id as string;
    const categoryId = params.categoryId as string;
    return await productApi.getCategoryById(clubId, categoryId);
  },
};
